import type { ReactNode } from 'react';
import React, { useState, useMemo } from 'react';
import graphqlClient from 'Utils/graphql-client/graphqlClient';
import { useAppContext } from 'Context/ReactAppContext';
import { getAllResorts } from './resortList.query';
import { ResortListContext } from './ResortListContext';
type Props = {
  children: ReactNode;
};
export const ResortListProvider = ({ children }: Props) => {
  const appContext = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [resortList, updateResortList] = useState<Array<ResortListItem>>([]);

  const setResortList = () => {
    if (resortList.length === 0 && !isLoading) {
      setIsLoading(true);
      graphqlClient
        .runQuery(
          `{${getAllResorts({
            withOpeningDates: true,
          })}}`,
          appContext,
        )
        .then((res) => updateResortList(res.resortList))
        .finally(() => setIsLoading(false));
    }
  };

  const value = useMemo(
    () => ({
      resortList,
      setResortList,
    }),
    [resortList],
  );
  return <ResortListContext.Provider value={value}>{children}</ResortListContext.Provider>;
};
